<template>
  <div v-if="!isPicture" class="grey-overlay flexing">
    <app-icon class="lock" icon-name="lock-sm" />
    <div class="grey-overlay-text text-28" v-html="greyOverlayText"></div>

    <div class="locked-message text-36 font-medium flexing">
      <div class="red-divider"></div>
      {{ $t('gallery.locked') }}
      <div class="red-divider"></div>
    </div>
  </div>

  <div v-else class="grey-overlay flexing">
    <app-icon class="lock" icon-name="lock-sm" />

    <div class="grey-overlay-text text-28 is-picture" v-html="greyOverlayText"></div>

    <div
      v-if="isLockedByPersonalBest"
      class="locked-message is-picture text-36 font-medium flexing flex-col"
    >
      <p>{{ $t('common.personalBest') }}</p>
      <p class="text-texts-standard-important">
        {{ formatResult(parseFloat(personalBest), disciplineId) }}
      </p>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, type PropType } from 'vue'
import { mapActions } from 'pinia'
import { formatResult } from '@/helpers'
import type { Nullable } from '@/interfaces/utils'
import { GalleryPictureUnlockCondition } from '@/interfaces/gallery/enums'
import { useGalleryPictureStore } from '@/store/pinia/gallery/pictureStore'

export default defineComponent({
  name: 'GalleryLockedItem',

  props: {
    isPicture: {
      type: Boolean,
      default: false,
    },

    unlockCondition: {
      type: String as PropType<Nullable<GalleryPictureUnlockCondition>>,
      default: null,
    },

    unlockConditionTarget: {
      default: null,
    },

    disciplineId: {
      type: Number,
      default: 1,
    },

    personalBest: {
      type: String,
      default: '',
    },
  },

  computed: {
    isLockedByPersonalBest(): boolean {
      return this.unlockCondition === GalleryPictureUnlockCondition.PersonalBest
    },

    greyOverlayText(): string {
      return this.getLockedText(
        this.unlockCondition,
        this.unlockConditionTarget,
        this.disciplineId || 0,
      )
    },
  },

  methods: {
    ...mapActions(useGalleryPictureStore, ['getLockedText']),
    formatResult,
  },
})
</script>

<style lang="scss" scoped>
.grey-overlay {
  position: absolute;
  inset: 0;
  background-color: rgba(59, 67, 74, 0.8);
  .grey-overlay-text {
    text-transform: none;
    width: 90%;
  }
  .lock {
    position: absolute;
    right: 1rem;
    top: 0.5rem;
  }

  .locked-message {
    width: 100%;
    height: 5rem;
    position: absolute;
    bottom: 1.25rem;
    left: 0;
    gap: 0.5rem;
    &.is-picture {
      height: 7rem;
    }
    @if $isWsm {
      background-image: linear-gradient(
        90deg,
        rgba(21, 78, 121, 0) 0%,
        rgba(21, 78, 121, 1) 15%,
        rgba(21, 78, 121, 1) 85%,
        rgba(21, 78, 121, 0) 100%
      );
    }
    @if $isSsm {
      background-image: linear-gradient(
        90deg,
        rgba(86, 98, 127, 0) 0%,
        rgba(86, 98, 127, 1) 15%,
        rgba(86, 98, 127, 1) 85%,
        rgba(86, 98, 127, 0) 100%
      );
    }

    .red-divider {
      width: 0.125rem;
      height: 2.3125rem;
      @if $isWsm {
        background-color: #377fb8;
      }
      @if $isSsm {
        background-color: #cb3d7e;
      }
    }
  }
}
</style>
